
import { ofType } from 'redux-observable'
import {of, forkJoin, timer} from 'rxjs'
import {
    map,
    switchMap,
    catchError,
    tap,
    concatMap,
    concatAll,


} from 'rxjs/operators'
import { fromFetch } from 'rxjs/fetch'
import changes from './changesDuck'
import {CATALOG_URL} from "../config";


const apiUrl = "https://s3.ca-central-1.amazonaws.com/geoconnection-test/20190710-30-18TXR-ndvi.json"

const rootURL = 'https://c-core-catalog-dev.s3.ca-central-1.amazonaws.com/s2-change-detection/index-based/'


export const changesEpic = (action$, state$) =>

  action$.pipe(
    ofType(changes.actions.fetchChangesRequest),
    switchMap(() =>
      fromFetch(getChangesfromState(state$)).pipe(switchMap(response => response.json()))
    ),
    map(result => changes.actions.fetchChangesSuccess(result)),
    catchError(error => {
      const action = changes.actions.fetchChangesFailure(error.message)

      return of(action)
    })
  )


export const changeLayerEpic = (action$, state$) =>

 action$.pipe(
    ofType(changes.actions.fetchChangesLayersRequest),
    switchMap(() =>
      fromFetch([CATALOG_URL, 'catalog.json'].join('')).pipe(switchMap(response => response.json()))
    ),

    map(json_obj => {
        return json_obj.links.filter(i => i.rel ==='item')}),

    concatMap(
        link_items=> forkJoin(
              ...link_items.map(x=> fromFetch([CATALOG_URL, x.href].join('')).pipe(
                  switchMap(
                result=>result.json()))))
    ), tap(x=> console.log(x)), map(result =>  changes.actions.fetchChangesLayersSuccess(result)
 ),
  )

function getChangesfromState (state) {
    const changeState = state.value.changes
    console.log(changeState)
    const activeLayer = changeState.layers[changeState.selected]
    console.log(activeLayer)
    if (!changeState) {return}
    return activeLayer.assets['ndvi'].href


}

// export default {changesEpic, changeLayerEpic}



// WEBPACK FOOTER //
// ./src/redux/changesEpic.js